import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './ArticleDetailPage.module.css';
import { CTASectionData } from './types';

import { img } from '@/lib/img';

interface CTASectionProps {
    data: CTASectionData;
}

export const CTASection: React.FC<CTASectionProps> = ({ data }) => {
    const {
        avatarImage,
        text,
        buttonText,
        buttonLink,
        backgroundColor = '#1a4d4d',
        variant = 'with-avatar'
    } = data;

    return (
        <div className={styles.ctaSection} style={{ backgroundColor }}>
            <div className={styles.ctaContent}>
                {variant === 'with-avatar' && avatarImage && (
                    <div className={styles.ctaAvatar}>
                        <Image
                            src={img(avatarImage.src)}
                            alt={avatarImage.alt}
                            width={avatarImage.width}
                            height={avatarImage.height}
                            className={styles.avatarImage}
                        />
                    </div>
                )}
                <p className={styles.ctaText}>{text}</p>
                <Link href={buttonLink} className={styles.ctaButton}>
                    {buttonText}
                </Link>
            </div>
        </div>
    );
};
